import axiosInstance from '../../../config/axiosInstance';

export type PlantDashboardOrder = {
  manufacturing_order_number: string;
  product_ref: string | null;

  pending_m: number;
  pending_fabrication_hours: number | null;
  pending_hours: number | null;
  dispatch_date: string | null;

  theoretical_dispatch_date: string | null;
  customer_number: string | null;
};


export type MaterialMassDiagnostics = {
  converted: number;
  product_not_resolved: number;
  no_technical_rule: number;
  ambiguous_basis: number;
  material_unclassified: number;
  material_category_unknown: number;
  material_category_excluded: number;
  missing_mass_unit: number;
  invalid_quantity: number;
  material_not_found: number;
};

export type PlantDashboardLine = {
  machine: string;
  orders_count: number;
  pending_m: number;
  known_pending_hours: number;
  orders_with_pending_hours: number;
  orders_without_pending_hours: number;
  workload_days: number | null;
  daily_capacity_hours: number;
  workload_target_working_days: number;
  workload_target_hours: number;
  pending_material_kg: number | null;
  pending_material_kg_orders_resolved: number;
  pending_material_kg_orders_unresolved: number;
  pending_material_kg_diagnostics: MaterialMassDiagnostics;
  produced_material_kg: number | null;
  orders: PlantDashboardOrder[];
};

export type PlantDashboardResponse = {
  snapshot: {
    id: string;
    source_file_name: string;
    published_at: string;
  } | null;

  summary: {
    orders_saved: number;
    orders_pending: number;
    orders_zero_pending: number;
    pending_meters: number;
    known_pending_hours: number;
    orders_with_pending_hours: number;
    orders_without_pending_hours: number;

    produced_material_kg: number | null;
    produced_material_kg_year: number;
    produced_material_kg_granularity: 'day' | 'month' | 'year' | null;
    produced_material_kg_rows_total: number;
    produced_material_kg_rows_resolved: number;
    produced_material_kg_rows_unresolved: number;
    produced_material_kg_diagnostics: MaterialMassDiagnostics;
    // IND-015: mismo periodo del año anterior (opcionales: backend previo).
    produced_material_kg_rows_unconverted?: number;
    previous_produced_material_kg?: number | null;
    previous_produced_material_kg_year?: number;
    previous_produced_material_kg_granularity?: 'day' | 'month' | 'year' | null;
    previous_produced_material_kg_rows_total?: number;
    previous_produced_material_kg_rows_unconverted?: number;

    pending_material_kg: number | null;
    pending_material_kg_orders_resolved: number;
    pending_material_kg_orders_unresolved: number;
    pending_material_kg_diagnostics: MaterialMassDiagnostics;

    material_mass_categories_total: number;
    material_mass_categories_included: number;
    material_mass_scope: string;
  };

  lines: PlantDashboardLine[];

  customer_deliveries: Array<{
    customer_number: string;
    orders_count: number;
    pending_m: number;
  }>;
};

export async function getIndustrialCostPlantDashboard():
  Promise<PlantDashboardResponse> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/plant-dashboard/overview',
  );

  return data as PlantDashboardResponse;
}